import React, { useState } from "react";
import styles from "./login.module.css";
import FormFields from "../../components/Form";
import { useNavigate } from "react-router-dom";
import Button from "common/Button";
import { postData } from "utils/queries";

const ForgotPasswordForm = () => {

  const navigate = useNavigate()

  const [email, setEmail] = useState();
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response =  await postData("auth/forgot-password",{email,role:"admin"})
      if(response){
          // navigate(`/reset-password?email=${email}&token=${response?.data?.token}`);
      }
    } catch (error) {
    }
  };

  const handleChange = () => {
    return (e) => {
      setEmail(e.target.value);
    };
  }


  const Fields = [
    {
      label: "Email",
      id: "email",
      placeholder: "Enter Email",
      type: "text",
      value: email,
      required: true,
      onChange: handleChange("email"),
    } 
  ];

  const resetPassword = () =>{
// navigate("/otp-verification")
  }

  return (
    <div className={styles.container}>
      <h2 htmlFor="email" className={styles.signInLabel}>
        Sign in
      </h2>

      <div className={styles.formContainer}>
        {/* {error && <p className={styles.error}>{error}</p>} */}
        <form onSubmit={handleSubmit}>
          <FormFields Fields={Fields} />
          <div className={styles.formGroup}>
            {/* <button type="submit"  onClick={()=>resetPassword()}>
            Reset Password
            </button> */}
            <Button label={"Reset Password"} buttonOverrideStyle={styles.button_} type="submit" onClick={()=>resetPassword()} />
          </div>
        </form>
        <div className={styles?.divider}></div>
        <div className={styles.signup}>
          <div className={styles.signUpInfo}>
          Already have a Flow account?
          </div>
          <button className={styles.registerButton} onClick={() => navigate("/")}>Sign In</button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
